import { formatDurationLabel } from "../utils";

interface TimeMarkersProps {
  traceDuration: number;
  markerCount?: number;
}

export const TimeMarkers = ({ traceDuration, markerCount = 5 }: TimeMarkersProps) => (
  <div className="absolute inset-0 w-full">
    {Array.from({ length: markerCount }).map((_, i) => {
      const markerKey = `marker-${i}-${traceDuration}`;
      const formattedDuration = formatDurationLabel((i * traceDuration) / (markerCount - 1));

      if (i === 0) {
        return (
          <div
            key={markerKey}
            className="absolute top-0 h-full border-l border-gray-300"
            style={{ left: `${(i * 100) / (markerCount - 1)}%` }}
          />
        );
      }

      return (
        <div
          key={markerKey}
          className="absolute top-0 h-full border-l border-gray-300"
          style={{ left: `${(i * 100) / (markerCount - 1)}%` }}
        >
          <span className="absolute -top-4 right-1 w-max text-[10px] font-medium text-gray-500">
            {formattedDuration}
            <div className="absolute -right-1 top-0 h-[16px] w-[1px] bg-gray-300" />
          </span>
        </div>
      );
    })}
  </div>
);
